import React, { useState } from 'react';
import SurveyForm2 from "../surveyform2/survey_form_2"; // import your survey form
import './Section_2.css';
import { DynamicIcon } from 'lucide-react/dynamic';


function Section2({ sectionConfig, onOpenSurvey }) {
const [showSurvey, setShowSurvey] = useState(false);
const handleCloseSurvey = () => {
    setShowSurvey(false);
  };
  // if (!sectionConfig || !sectionConfig.items) return null;
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: `repeat(${sectionConfig.itemCount}, 1fr)`,
    gap: "20px",
  };

const getLucideIcon = (iconName, size =35) => {
             if (!iconName) return null;
             return <DynamicIcon name={iconName} size={size} />;
           };

  return (
    <>
    <section className="section-2">
      <h1 className="section-2-title">{sectionConfig.title} </h1>
      <div className="item-grid" style={gridStyle}>
        {sectionConfig.items.map((item, idx) => (
          <div key={idx} className="item-card">
            <div className="item-icon">{getLucideIcon(item.icon)}</div>
            <div className="item-title"><strong>{item.title}</strong></div>
            <div className="item-subtitle">{item.subtitle}</div>
          </div>
        ))}
      </div>
    </section>
    {/* Survey modal */}
      {showSurvey && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={handleCloseSurvey}>
              ✖
            </button>
            <SurveyForm2 />
          </div>
        </div>
      )}
    </>
  );
}

export default Section2;